export enum Role {
    Admin = 'ADMIN',
    Gestor = 'USER',
    SuperAdmin = 'SUPER_ADMIN',
    RRHH= 'RRHH',
    EXECUTIVE = 'EXECUTIVE'
}
